<header>
	<div class="channel-info">

		<div class="stats">

			<span class="connection">
				@if( core.ws_conn; as con ){
					<i class="material-icons" [class]="'state_' + con.readyState">
						{{ ['sync', 'wifi', 'sync_problem', 'sync_disabled'][con.readyState] }}
					</i>
				} @else {
					<i class="material-icons">wifi_find</i>
				}
				<span *ngIf="core.ws_latency_ms" class="ping">PING {{ core.ws_latency_ms }}ms</span>
			</span>

			Waiting on Parent Site...

		</div>

		<div class="list">
			@for (channel of core.channel_list; track channel.name){
				<button *ngIf="!core.getChannelAction( channel, 'H' )"
					class="action channel"
					[class.blocked]="'Premium'==channel.name"
					[class.current]="channel.name == core.channel_name"
					(click)="channel_info = channel_info ? null : channel ">

					{{ channel.name }}
				</button>
			}
		</div>

	</div>


	<div class="persona" (click)="overlay_toggle('auth')">

		@if( core.user && !core.persona ) {
			<div class="info">
				<i class="material-icons">person</i>
				<span>You</span>
			</div>
		} @else if( core.user && core.persona ) {
			@let p = core.persona;
			<div class="avatar" >
				<img [src]="p.avatar" />
			</div>

			<div class="row">
				<span class="username">{{ p.username }}</span>
				<i class="material-icons" *ngIf="p.badge">{{ p.badge }}</i>
			</div>
			<div class="row">
				<span class="title">{{ core.personality.role | titlecase }}</span>
				<i class="material-icons">settings</i><span> My Profile</span>
			</div>
		} @else if( core.user_whoami_timestamp == null ) {
			<div class="info">
				<i class="material-icons">cloud_sync</i>
				<span>...</span>
			</div>
		} @else {
			<div class="info">
				<i class="material-icons">key</i>
				<span>Login</span>
			</div>
		}

	</div>
</header>


<div class="main-content">
	<app-chat />
	@switch( overlay_active ){
		@case ('channel') {
			<app-channel *ngIf="channel_info" [info]="channel_info" />
		}
		@case ('auth') {
			@defer {
				<app-auth />
			} @loading (after 100ms; minimum 1s) {
				<div class="loading"><p>Loading Login Overlay...</p></div>
			}
		}
	}

</div>
<!--footer *ngIf="core.personality">
	<div class="info-line">
		<!--span class="typing" *ngIf="unread_count == 0">{{ typing_message }}</span>
		<span class="unread" *ngIf="unread_count >= 1" (click)="core.scroll_event.emit(null)">
			{{ unread_count }} Unread Message{{ unread_count==1 ? '' : 's'  }}
			<i class="material-icons">arrow_downward</i>
		</span>

		<span class="seperator"></span>


		<i class="scroll-state material-icons" [class.locked]="scroll_locked" (click)="scroll_manual=!scroll_manual">{{ scroll_locked ? 'lock' : 'lock_open' }}<span *ngIf="scroll_manual">block</span></i>
	</div>
	<div class="message-box">
		<button class="action emoticons" (click)="emojibox_init=true; emojibox_open=!emojibox_open"><i class="material-icons">emoji_emotions</i></button>
		<div class="message-text-box" (click)="message_box.focus()" [class.command-mode]="is_command">
			<div class="chatmessage" #ghost_box>
				{{ message }}<span class="user-suggestion" *ngIf="message.endsWith('@Q')">ueue A</span>
			</div>
			<textarea class="chatmessage" rows="1" placeholder="Message" [maxlength]="core.personality.character_limit"
				#message_box [style.min-height.px]="ghost_box.scrollHeight - 14"
				(keydown.enter)="sendMessage( $event )" (keyup)="typingStatus( $event )" [(ngModel)]="message"></textarea>
		</div>
		<button class="action send" (click)="sendMessage( $event )" [class.disabled]="cooldown_tuple[0] == 0">
			<i class="material-icons">send</i>
			<small class="counter" *ngIf="cooldown_tuple[1] > 1">{{ cooldown_tuple[0] }}</small>
		</button>
	</div>
	<div class="emojibox-wrapper" [class.shown]="emojibox_open">
		<div class="emojibox" #emoji_box *ngIf="emojibox_init">
			<div class="groups" *ngFor="let group of emojis" [style.padding-left.px]="(emoji_box.scrollWidth % 32) / 2">
				<button class="emoji_picker" *ngFor="let e of group" (click)="appendEmoji(e[0])" (focus)="message_box.focus()" [innerHTML]="e[1]" tabindex="-1"></button>
			</div>
		</div>
	</div>
</footer-->
